// ADR 0022 -- the marks the paper and the SVG export share for the bonds that aren't plain lines:
// the wavy bond's wave, and the bolt the paper draws between a salt's ions.

/** A wave from one end to the other: half-waves of about two amplitudes each, alternating sides. */
export function wavyBondPath(x1: number, y1: number, x2: number, y2: number, amplitude: number): string {
  const length = Math.hypot(x2 - x1, y2 - y1);
  if (length === 0 || amplitude <= 0) return `M${x1} ${y1}L${x2} ${y2}`;
  const halfWaves = Math.max(2, Math.round(length / (2 * amplitude)));
  const nx = -(y2 - y1) / length;
  const ny = (x2 - x1) / length;
  const round = (value: number) => Math.round(value * 10) / 10;
  let path = `M${round(x1)} ${round(y1)}`;
  for (let index = 0; index < halfWaves; index++) {
    const side = index % 2 === 0 ? 1 : -1;
    const middle = (index + 0.5) / halfWaves;
    const end = (index + 1) / halfWaves;
    const cx = x1 + (x2 - x1) * middle + nx * amplitude * 2 * side;
    const cy = y1 + (y2 - y1) * middle + ny * amplitude * 2 * side;
    path += `Q${round(cx)} ${round(cy)} ${round(x1 + (x2 - x1) * end)} ${round(y1 + (y2 - y1) * end)}`;
  }
  return path;
}

/**
 * ADR 0022 (as amended) -- the bolt between two ions: a lightning zig-zag from one to the other,
 * kinking `width` to either side of the line about its middle, so it stretches with the ions.
 */
export function ionicBoltPath(x1: number, y1: number, x2: number, y2: number, width: number): string {
  const length = Math.hypot(x2 - x1, y2 - y1) || 1;
  const nx = (-(y2 - y1) / length) * width;
  const ny = ((x2 - x1) / length) * width;
  const at = (t: number, side: number) =>
    `${Math.round((x1 + (x2 - x1) * t + nx * side) * 10) / 10} ${Math.round((y1 + (y2 - y1) * t + ny * side) * 10) / 10}`;
  return `M${at(0, 0)}L${at(0.42, 1)}L${at(0.58, -1)}L${at(1, 0)}`;
}
